import React, { useState } from 'react';
import Image from 'next/image';
import { isDevelopment } from '../helpers/environment';

const normalizeSrc = (src) => (src.startsWith('/') ? src.slice(1) : src);

const loaderPureOriginal = ({ src }) => src.replace('_big.', '_original.');

const getFallbackUrl = (src) => `${normalizeSrc(src)}`;

const loaderCloudflare = ({ src, width, quality }) => {
  if (isDevelopment()) {
    return getFallbackUrl(src);
  }

  const params = [`width=${width},format=webp`];
  if (quality) {
    params.push(`quality=${quality}`);
  }
  const paramsString = params.join(',');

  return `https://img.ps.me/cdn-cgi/image/${paramsString}/${normalizeSrc(src)}`;
};

const loaderFallback = ({ src }) => getFallbackUrl(src);

export const loaderCloudflareOriginal = ({ src, width, quality }) => loaderCloudflare({
  src: loaderPureOriginal({ src }),
  width,
  quality,
});

function ImageWrapper({ src, onError, ...props }) {
  const [useFallback, setUseFallback] = useState(false);

  const handleError = (e) => {
    if (!useFallback) {
      setUseFallback(true);
    }
    if (onError) {
      onError(e);
    }
  };

  if (useFallback) {
    return <Image loader={loaderFallback} src={src} onError={handleError} {...props} />;
  }

  return <Image loader={loaderCloudflare} src={src} onError={handleError} {...props} />;
}

export function SlideImageWrapper({ src, onError, ...props }) {
  const [useFallback, setUseFallback] = useState(false);

  const handleError = (e) => {
    if (!useFallback) {
      setUseFallback(true);
    }
    if (onError) {
      onError(e);
    }
  };

  const fallbackSrc = loaderPureOriginal({ src });

  if (useFallback) {
    return <Image loader={loaderFallback} src={fallbackSrc} onError={handleError} {...props} />;
  }

  return <Image loader={loaderCloudflareOriginal} src={src} onError={handleError} {...props} />;
}

export default ImageWrapper;
